import styled from 'styled-components/macro';

export const Title = styled.h3`
    font-family: Averta;
    font-size: 28px;
    line-height: 34px;
    color: #000000;
    margin: 0 0 10px 0;
    font-weight: 300;

    @media (max-width: 36.5em) {
        font-size: 25px;
        line-height: 31px;
    }

    @media (max-width: 30em) {
        font-size: 24px;
        line-height: 30px;
    }
`;

export const Bold = styled.span`
    font-weight: bold;
`;

export const Span = styled.span`
    ${props => (props.color ? 'color: ' + props.color : 'color: #000')};
`;
